module.exports = __webpack_public_path__ + "img/MK.daf6abdd.svg";